import { LockableAmount } from 'components/common-form/builder/form/node/field/LockableAmountField/LockableAmount';
import { ProductNodeBuilderProps } from 'components/common-form/builder/form/node/ProductNodeBuilder.model';
import { useData } from 'components/common-form/hooks/useData';
import { ConfirmModal } from 'components/shared/Modals/ConfirmModal';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

export function NotionalTradedSoFarAmountField({ node, tabIndex, ...props }: ProductNodeBuilderProps) {
  const [value, setValue] = useData<number>(node.id);
  const [isLockedValue, setIsLockedValue] = useState<boolean | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onLockChanged = useCallback(
    (locked: boolean) => {
      setIsLockedValue(locked);
      if (locked) {
        setValue(null);
      }
    },
    [setValue],
  );

  const onCancelEdit = useCallback(() => {
    setIsLockedValue(true);
    setIsModalOpen(false);
  }, []);

  const onConfirmEdit = useCallback(() => {
    onLockChanged(false);
    setIsModalOpen(false);
  }, [onLockChanged]);

  return (
    <>
      <LockableAmount
        isDelegatedLock
        node={node}
        value={value}
        isLockedValue={isLockedValue}
        onLockChanged={isLocked => {
          if (isLocked) {
            onLockChanged(isLocked);
          } else {
            setIsModalOpen(true);
          }
        }}
        onValueChanged={v => {
          setValue(v);
        }}
        tabIndex={tabIndex}
        {...props}
      />
      <ConfirmModal
        contentClassName="border border-1 border-warning"
        show={isModalOpen}
        size="xl"
        confirmBtnClassName="btn btn-warning"
        header={{ className: 'text-warning' }}
        titleKey="form.NotionalTradedSoFar.modal.title"
        confirmBtnKey="form.NotionalTradedSoFar.modal.confirm"
        onClosed={onCancelEdit}
        onConfirm={onConfirmEdit}
      >
        <FormattedMessage id="form.NotionalTradedSoFar.modal.body.p1" values={{ b: txt => <b>{txt}</b> }} />
        <br />
        <br />
        <FormattedMessage id="form.NotionalTradedSoFar.modal.body.p2" values={{ b: txt => <b>{txt}</b> }} />
        <br />
        <br />
        <FormattedMessage id="form.NotionalTradedSoFar.modal.body.p3" values={{ b: txt => <b>{txt}</b> }} />
        <br />
        <br />
        <FormattedMessage id="form.NotionalTradedSoFar.modal.body.p4" values={{ b: txt => <b>{txt}</b> }} />
      </ConfirmModal>
    </>
  );
}
